import { useState, useEffect, useCallback } from "react";
import type { StarterKitManifest } from "@/types";

export function useStarterKit() {
  const [kits, setKits] = useState<StarterKitManifest[]>([]);
  const [loading, setLoading] = useState(false);

  const loadKits = useCallback(async () => {
    setLoading(true);
    try {
      const available = await window.freshvibe.getStarterKits();
      setKits(available);
    } catch {
      // No kits available
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadKits();
  }, [loadKits]);

  const selectFolder = useCallback(async () => {
    const dir = await window.freshvibe.selectWorkingDirectory();
    return dir ?? null;
  }, []);

  return {
    kits,
    loading,
    loadKits,
    selectFolder,
  };
}
